import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const NotificationOffIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.714 15.429H6.286V9.714a5.714 5.714 0 0 1 11.428 0v5.715ZM4.571 15.429H19.43M9.714 17.143v.571a2.286 2.286 0 1 0 4.572 0v-.571"
        stroke={iconColor}
        strokeWidth={1.5}
        strokeLinecap="round"
        fill={iconColor}
        fillOpacity={0.15}
      />
      <path
        d="M4.47 19.53a.75.75 0 0 0 1.06 0l14-14a.75.75 0 0 0-1.06-1.06l-14 14a.75.75 0 0 0 0 1.06Z"
        fill={iconColor}
      />
    </Box>
  );
};
